import { createSelector } from 'reselect';

import { rcsSupplierInfo } from '../RcsSupplierInfoSelectors';

/* eslint-disable import/prefer-default-export */

function crnSelector(state, ownProps) {
  return ownProps.crn;
}

function databaseIdSelector(state, ownProps) {
  return ownProps.databaseId;
}

export function rcsSupplierInfoByIdFactory() {
  return createSelector([rcsSupplierInfo, databaseIdSelector, crnSelector], (rcsSupplierInfoMap, databaseId, crn) =>
    rcsSupplierInfoMap.getIn([databaseId, crn])
  );
}
